import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatomoTracker } from 'ngx-matomo-client';

/**
 * Custom constent modal
 * to ask for user consent for analytics tracking
 * @class CookieConsentComponent
 * @typedef {CookieConsentComponent}
 */
@Component( {
    selector: 'app-cookie-consent',
    imports: [ MatCardModule, MatSlideToggleModule, MatButtonModule, MatDividerModule, MatDialogModule ],
    templateUrl: './cookie-consent.component.html',
    styleUrl: './cookie-consent.component.scss'
} )
export class CookieConsentComponent {
    data = inject<{ simple: boolean; checked: boolean }>( MAT_DIALOG_DATA );
    dialogRef = inject<MatDialogRef<CookieConsentComponent>>( MatDialogRef );

    readonly tracker = inject( MatomoTracker );

    checked = false;

    acceptAll = $localize`:@@cookies-accept-all:Accept all cookies`;
    rejectAll = $localize`:@@cookies-reject-all:Reject optional cookies`;

    allowTracking = $localize`:@@performance-tracking-allow:Allow tracking`;
    disallowTracking = $localize`:@@performance-tracking-disallow:Do not allow tracking`;

    /**
     * Creates an instance of CookieConsentComponent.
     * @class
     * @param data object of data properies passed into the modal
     * @param data.simple - flag whether to show default dialog
     * @param data.checked - flag if cosent was given before
     * @param dialogRef reference on dialog modal
     */
    constructor() {
        this.checked = this.data.checked;
    }

    /**
     * helper function to handle consent choice
     */
    handleConsent() {
        if ( this.checked ) {
            this.tracker.forgetUserOptOut();
            this.tracker.rememberConsentGiven();
            this.tracker.enableLinkTracking();
        } else {
            this.tracker.optUserOut();
        }
        this.dialogRef.close( this.checked );
    }
}
